export default "__VITE_ASSET__c9e91683__"